import React from "react";
import { NavLink } from "react-router-dom";
import { useBusiness } from "../context/BusinessContext";
import { Sprout, Wrench, Truck, Calendar, LayoutGrid, LineChart } from "lucide-react";

const ICON_BY_TYPE = {
  farm: Sprout,
  repair: Wrench,
  trucking: Truck,
};

const ENTRY_PATH = {
  farm: "/",
  jk_repair: "/repair",
  jk_trucking: "/trucking",
};

const tabClass = (active) =>
  `flex items-center gap-2 px-4 py-2.5 text-[12px] font-semibold tracking-tight rounded-full transition-all whitespace-nowrap ${
    active
      ? "bg-white text-[#1F2A47] shadow-sm"
      : "text-slate-300 hover:text-white hover:bg-white/5"
  }`;

/**
 * Top-level horizontal tab bar.
 * 3 business tabs (Farm, Repair, Trucking) + Calendar + Markets + Hub.
 * Active tab is driven by URL + BusinessContext.
 */
export default function TopTabs() {
  const { businesses, active, setActive } = useBusiness();

  return (
    <div className="no-print bg-[#1F2A47] sticky top-0 z-30 shadow-sm" data-testid="top-tabs">
      <div className="px-4 md:px-8 py-2 flex items-center gap-1.5 overflow-x-auto">
        {businesses.map((b) => {
          const Icon = ICON_BY_TYPE[b.type] || LayoutGrid;
          const path = ENTRY_PATH[b.id] || "/";
          const isActive = active === b.id;
          return (
            <NavLink
              key={b.id}
              to={path}
              onClick={() => setActive(b.id)}
              data-testid={`top-tab-${b.id}`}
              className={tabClass(isActive)}
            >
              <Icon className="w-4 h-4" strokeWidth={2} />
              {b.name}
            </NavLink>
          );
        })}
        <div className="w-px h-5 bg-white/10 mx-2" />
        <NavLink to="/calendar" data-testid="top-tab-calendar" className={({ isActive }) => tabClass(isActive)}>
          <Calendar className="w-4 h-4" strokeWidth={2} /> Calendar
        </NavLink>
        <NavLink to="/markets" data-testid="top-tab-markets" className={({ isActive }) => tabClass(isActive)}>
          <LineChart className="w-4 h-4" strokeWidth={2} /> Markets
        </NavLink>
        <NavLink to="/hub" data-testid="top-tab-hub" className={({ isActive }) => tabClass(isActive)}>
          <LayoutGrid className="w-4 h-4" strokeWidth={2} /> Hub
        </NavLink>
      </div>
    </div>
  );
}
